import { useMutation, useQueryClient } from '@tanstack/react-query';
import { refreshEmployeeStatus } from '../../../services/MoodleService';
import { moodleQueryKeys } from '../all-query-keys';

export const useRefreshEmployeeStatus = (onSuccess) => {
  const queryClient = useQueryClient();

  const { mutate, isPending } = useMutation({
    mutationFn: (email) => refreshEmployeeStatus(email),
    onSuccess: (...args) => {
      queryClient.invalidateQueries({
        queryKey: moodleQueryKeys.courseCompletionReports(),
      });
      queryClient.invalidateQueries({
        queryKey: moodleQueryKeys.getConfiguredCourses(),
      });
      onSuccess?.(...args);
    },
  });

  return { mutate, isPending };
};
